'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeByName = exports.blue = exports.red = exports.green = undefined;

var _colorManipulator = require('material-ui/utils/colorManipulator');

var _spacing = require('material-ui/styles/spacing');

var _spacing2 = _interopRequireDefault(_spacing);

var _zIndex = require('material-ui/styles/zIndex');

var _zIndex2 = _interopRequireDefault(_zIndex);

var _getMuiTheme = require('material-ui/styles/getMuiTheme');

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var green = exports.green = (0, _getMuiTheme2.default)({
  name: 'green',
  spacing: _spacing2.default,
  zIndex: _zIndex2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.teal700,
    primary2Color: _colors.teal400,
    primary3Color: _colors.lightBlack,
    accent1Color: _colors.teal400,
    accent2Color: _colors.grey100,
    accent3Color: _colors.teal400,
    textColor: _colors.darkBlack,
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.teal700
  }
});

var red = exports.red = (0, _getMuiTheme2.default)({
  name: 'red',
  spacing: _spacing2.default,
  zIndex: _zIndex2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.red700,
    primary2Color: _colors.red400,
    primary3Color: _colors.lightBlack,
    accent1Color: _colors.red400,
    accent2Color: _colors.grey100,
    accent3Color: _colors.red400,
    textColor: _colors.darkBlack,
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.red700
  }
});

var blue = exports.blue = (0, _getMuiTheme2.default)({
  name: 'blue',
  spacing: _spacing2.default,
  zIndex: _zIndex2.default,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: _colors.blue700,
    primary2Color: _colors.blue400,
    primary3Color: _colors.lightBlack,
    accent1Color: _colors.blue400,
    accent2Color: _colors.grey100,
    accent3Color: _colors.blue400,
    textColor: _colors.darkBlack,
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.blue700
  }
});

var themes = [red, green, blue];

exports.default = themes;
var getThemeByName = exports.getThemeByName = function getThemeByName(name) {
  var filteredThemes = themes.filter(function (theme) {
    return theme.name === name;
  });
  return filteredThemes ? filteredThemes[0] : null;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/style/themes.js
 ** module id = 282
 ** module chunks = 0
 **/